/* eslint-disable max-len */
/* eslint-disable react/no-unused-state */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SavePromptModal from '../../../components/Modals/SavePromptModal';

import { GOLDEN_GOAL_SETTINGS_INPUTS, MODALS, PERMISSIONS } from '../../../constants';
import {
  checkPermisson, getActiveModal, getLeagues, getNextNavigationLink,
} from '../../../selectors/common';
import { goldenGoalSettingsSelector } from '../../../selectors/goldenGoalSettings';
import validateFields from '../../../utils/validation';
import GoldenGoalSettingsRow from './GoldenGoalSettingsRow';
import { aGetGoldenGoalSettingsRequest, aUpdateGoldenGoalSettingsRequest } from '../../../reducers';
import { aSetNavigationInfo, aSetOpenModal } from '../../../reducers/common';

const mapToProps = (state) => ({
  leagues: getLeagues(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
  activeModal: getActiveModal(state),
  nextNavigationLink: getNextNavigationLink(state),
  goldenGoalSettings: goldenGoalSettingsSelector(state),

});

const actionsToProps = (dispatch) => ({
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
  setNavigationInfo: (payload) => dispatch(aSetNavigationInfo(payload)),
  getGoldenGoalSettings: (payload) => dispatch(aGetGoldenGoalSettingsRequest(payload)),
  updateGoldenGoalConfig: (payload) => dispatch(aUpdateGoldenGoalSettingsRequest(payload)),
});

class GoldenGoalSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goldenGoalSettings: null,
      rowBeingEditted: null,
      hasChanges: false,
      errors: {},
    };
  }

  componentDidMount() {
    this.props.getGoldenGoalSettings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.goldenGoalSettings === null && this.props.goldenGoalSettings?.length > 0) {
      const goldenGoalSettingsCopy = this.props.goldenGoalSettings?.map((settings) => ({ ...settings, config: { ...settings?.config } }));
      this.setState({
        goldenGoalSettings: goldenGoalSettingsCopy,
      });
    }
    if (prevState.hasChanges === false && this.state.hasChanges === true) {
      this.props.setNavigationInfo({ requiresSaveBeforeNavigation: true });
    }
  }

  getLeagueName = (leagueId) => {
    if (!leagueId) return '';
    return this.props.leagues?.find((league) => league?.id === leagueId)?.name;
  };

  updateSelectedRow = (rowId) => {
    const rowBeingEditted = this.state.rowBeingEditted === rowId ? null : rowId;
    this.setState({
      rowBeingEditted,
    });
  };

  cancelChanges = () => {
    this.setState({
      rowBeingEditted: null,
      goldenGoalSettings: this.props.goldenGoalSettings,
      hasChanges: false,
      errors: {},
    });
  };

  updateInputs = (value, type) => {
    const updatedGoldenGoalSettings = [...this.state.goldenGoalSettings?.map((settings) => ({ ...settings, config: { ...settings?.config } }))];
    const settingsIdx = this.state.goldenGoalSettings
      ?.findIndex((setting) => setting?.competitionId === this.state.rowBeingEditted);
    let updatedSettings = {
      ...this.state.goldenGoalSettings
        ?.find((setting) => setting?.competitionId === this.state.rowBeingEditted),
    };

    if (Object.keys(updatedSettings)?.length === 0) return;
    updatedSettings = { ...updatedSettings, config: { ...updatedSettings?.config } };

    if (type === GOLDEN_GOAL_SETTINGS_INPUTS.MAX_PROB) {
      updatedSettings.config.maxProbability = value;
    } else if (type === GOLDEN_GOAL_SETTINGS_INPUTS.WINN_COEFF) {
      updatedSettings.config.winningProbabilityCoefficient = value;
    }

    updatedGoldenGoalSettings[settingsIdx] = updatedSettings;

    this.setState({
      goldenGoalSettings: updatedGoldenGoalSettings,
      hasChanges: true,
    });
  };

  clearErrors = () => {
    this.setState({
      errors: {},
    });
  };

  saveChanges = () => {
    this.clearErrors();

    const validationParams = [];
    for (let i = 0; i < this.state.goldenGoalSettings?.length; i += 1) {
      validationParams.push({
        label: 'Maximum Probability',
        fieldName: `maximumProbability-${i}`,
        value: this.state.goldenGoalSettings?.[i]?.config?.maxProbability,
        rules: ['betweenXAndY'],
        minValue: 0,
        comparatorMaxValue: 1,
        getValue: (val) => val,
      },
      {
        label: 'Winning Probability Coeff',
        fieldName: `winningProbabilityCoefficient-${i}`,
        value: this.state.goldenGoalSettings?.[i]?.config?.winningProbabilityCoefficient,
        rules: ['betweenXAndY'],
        minValue: 0,
        comparatorMaxValue: 1,
        getValue: (val) => val,
      });
    }

    validateFields(validationParams)
      .then(() => {
        const competitionId = this.state.rowBeingEditted;
        const leagueName = this.getLeagueName(competitionId);
        const config = this.state.goldenGoalSettings?.find((settings) => settings?.competitionId === competitionId)?.config;
        this.props.updateGoldenGoalConfig({
          competitionId,
          config: {
            maxProbability: Number(config?.maxProbability),
            winningProbabilityCoefficient: Number(config?.winningProbabilityCoefficient),
          },
          leagueName,
        });

        this.props.setNavigationInfo({ requiresSaveBeforeNavigation: false });

        this.setState({
          rowBeingEditted: null,
          hasChanges: false,

        });
      }).catch((errorMgs) => {
        this.setState({
          errors: errorMgs,
        });
      });

    if (this.props.activeModal) {
      this.props.setOpenModal({ modal: '' });
    }
  };

  discardChangesAndProceed = () => {
    this.props.setOpenModal({ modal: '' });

    this.props.setNavigationInfo({ requiresSaveBeforeNavigation: false });
    if (this.props.nextNavigationLink) {
      this.props.navigate(this.props.nextNavigationLink);
    }
  };

  render() {
    const hasPermissionToUpdate = this.props.checkPermisson(PERMISSIONS.GOLDEN_GOAL_CONFIG_UPDATE);
    return (

      <div className="table-holder">
        <table className="table-style table-style--fixed">
          <thead>
            <tr>
              <th>League</th>
              <th>Maximum Probability</th>
              <th>Winning Probability Coefficient</th>
              {hasPermissionToUpdate && (<th> </th>)}
            </tr>
          </thead>

          <tbody>
            {this.state.goldenGoalSettings?.map((settings, idx) => (

              <GoldenGoalSettingsRow
                key={`goldenGoalSettingsRow-${settings?.competitionId}`}
                rowBeingEditted={this.state.rowBeingEditted}
                settings={settings}
                getLeagueName={this.getLeagueName}
                idx={idx}
                updateInputs={this.updateInputs}
                hasPermissionToUpdate={hasPermissionToUpdate}
                updateSelectedRow={this.updateSelectedRow}
                saveChanges={this.saveChanges}
                cancelChanges={this.cancelChanges}
                errors={this.state.errors}

              />

            ))}

          </tbody>
        </table>

        {this.props.activeModal === MODALS.SAVE_BEFORE_NAVIGATION && (
          <SavePromptModal
            modalData={{
              title: 'Do you want to save the changes?',
              additionalMessages: ['Your changes will be lost if you don\'t save them'],
            }}
            cancel={this.discardChangesAndProceed}
            confirmation={this.saveChanges}
            confirm="Save"
            cancelled="Don't Save"
          />
        )}

      </div>

    );
  }
}

export default connect(mapToProps, actionsToProps)(GoldenGoalSettings);
